@if (cards$ | async; as cards) {
  @if (!(isLoading$ | async)) {
    <cx-payment-form
      (setPaymentDetails)="setPaymentDetails($event)"
      (closeForm)="hideNewPaymentForm()"
      (goBack)="back()"
      [paymentMethodsCount]="cards?.length || 0"
      [setAsDefaultField]="!isGuestCheckout"
    ></cx-payment-form>
  } @else {
    <div class="cx-spinner"><cx-spinner></cx-spinner></div>
  }
}
